import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './global.css'

// Disable console logs in production for security and cleanliness
if (import.meta.env.PROD) {
  console.log = () => { };
  console.info = () => { };
  console.warn = () => { };
  console.debug = () => { };
  // Keep console.error for critical crash reports, or disable if strict requirement
  // console.error = () => {}; 
}

console.log('🚀 main.tsx is loading');

const root = ReactDOM.createRoot(document.getElementById('root')!)

// Add error handling for the render process
try {
  console.log('🔄 Attempting to render React app...');
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
  console.log('✅ App rendered successfully');
} catch (error) {
  console.error('❌ Failed to render app:', error);

  // Fallback render with more detailed error info
  root.render(
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'system-ui, sans-serif',
      backgroundColor: '#f9fafb'
    }}>
      <div style={{ textAlign: 'center', maxWidth: '500px', padding: '2rem' }}>
        <h1 style={{ color: '#dc2626', marginBottom: '1rem', fontSize: '1.5rem' }}>
          🚨 Application Failed to Load
        </h1>
        <p style={{ color: '#6b7280', marginBottom: '1rem', lineHeight: '1.5' }}>
          The application encountered an error during initialization. This might be due to:
        </p>
        <ul style={{ color: '#6b7280', marginBottom: '1.5rem', textAlign: 'left' }}>
          <li>• Network connectivity issues</li>
          <li>• Server not running on port 3001</li>
          <li>• Authentication service unavailable</li>
          <li>• JavaScript errors in components</li>
        </ul>
        <div style={{ marginBottom: '1.5rem' }}>
          <details style={{ textAlign: 'left', marginBottom: '1rem' }}>
            <summary style={{ cursor: 'pointer', color: '#3b82f6', marginBottom: '0.5rem' }}>
              Technical Details
            </summary>
            <pre style={{
              backgroundColor: '#f3f4f6',
              padding: '0.5rem',
              borderRadius: '0.25rem',
              fontSize: '0.75rem',
              overflow: 'auto',
              color: '#374151'
            }}>
              {error instanceof Error ? error.message : String(error)}
            </pre>
          </details>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
          <button
            onClick={() => window.location.reload()}
            style={{
              backgroundColor: '#3b82f6',
              color: 'white',
              padding: '0.5rem 1rem',
              border: 'none',
              borderRadius: '0.5rem',
              cursor: 'pointer'
            }}
          >
            Reload Page
          </button>
          <button
            onClick={() => console.log('Manual debug triggered')}
            style={{
              backgroundColor: '#6b7280',
              color: 'white',
              padding: '0.5rem 1rem',
              border: 'none',
              borderRadius: '0.5rem',
              cursor: 'pointer'
            }}
          >
            Debug Console
          </button>
        </div>
      </div>
    </div>
  )
}
